import React, { useContext, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import loginImg from "../../assets/all-images/bg11.jpg";
import "../../styles/product-details.css";

const trustPoints = [
  "Experience seamless order tracking for your premium Ethiopian gemstones.",
  "Save your favorite gemstone selections for easy access anytime.",
  "Enjoy a smooth, uninterrupted checkout tailored for gemstone enthusiasts.",
];

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
// const hasGoogleClientId =
//   !!googleClientId && googleClientId !== "YOUR_GOOGLE_CLIENT_ID";

const Login = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const emailIsValid = useMemo(() => emailPattern.test(email.trim()), [email]);
  const formIsValid = emailIsValid && password.trim().length >= 6;

  const goAfterAuth = (role) => {
    navigate(role === "admin" ? "/admin/dashboard" : "/");
  };

  // Removed Google login handler

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!formIsValid) {
      setError("Enter a valid email and password to continue.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await login(email.trim(), password);
      goAfterAuth(response.role);
    } catch (err) {
      setError(err.response?.data?.error || err.message || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="roha-auth-page">
      <div className="roha-auth-shell">
        <section className="roha-auth-showcase">
          <img
            src={loginImg}
            alt="Roha Jewellery login experience"
            className="roha-auth-showcase__image"
          />
          <div className="roha-auth-showcase__overlay" />
          <div className="roha-auth-showcase__content">
            <p className="roha-eyebrow">Client access</p>
            <h1>Welcome to Roha Jewellery – Ethiopia’s Premier Gemstone Destination.</h1>
            <p>
              Sign in to explore, order, and manage your exclusive Ethiopian gemstone collection with ease and confidence.
            </p>
            <div className="roha-auth-trust">
              {trustPoints.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </div>
        </section>

        <section className="roha-auth-card">
          <div className="roha-auth-card__inner">
            <div className="roha-auth-heading">
              <p className="roha-eyebrow">Member Login</p>
              <h2>Access Your Roha Jewellery & Gemstone Collection Account</h2>
              <p className="roha-auth-card__intro">
                Use your email to sign in and unlock the finest Ethiopian gemstones and personalized service.
              </p>
            </div>

            {error && <div className="roha-auth-alert roha-auth-alert--error">{error}</div>}

            {/* Google login removed for today */}

            <div className="roha-auth-divider">
              <span>or sign in with your email</span>
            </div>

            <form className="roha-auth-form" onSubmit={handleLogin}>
              <label>
                <span>Email address</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  required
                />
              </label>

              <label>
                <span>Password</span>
                <div className="roha-auth-password">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                    required
                  />
                  <button type="button" onClick={() => setShowPassword((prev) => !prev)}>
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </label>

              <div className="roha-auth-meta">
                <span>Secure access for your saved orders and account details.</span>
                <Link to="/register">Create account</Link>
              </div>

              <button
                type="submit"
                className="roha-button roha-button--solid"
                disabled={loading || !formIsValid}
              >
                {loading ? "Signing in..." : "Sign in securely"}
              </button>
            </form>

            <p className="roha-auth-footer">
              New to Roha Jewellery? <Link to="/register">Join Ethiopia’s gemstone community</Link>
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Login;
